<template>
  <form-layout class="trust-form-layout">
    <span slot="title">激活委托</span>
    <div class="table_area" slot="main-content">
      <div class="item-box" v-for="(item, index) in activebox">
        <table>
          <thead>
            <tr>
              <td width="100">批次号</td>
              <td width="260">物料名称</td>
              <td width="100">品项</td>
              <td width="100">品牌</td>
              <td width="100">机型</td>
              <td width="100">模块</td>
              <td width="100">数量</td>
              <td width="180">委托时长</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {{item.ProductCode}}
              </td>
              <td>
                {{item.ProductName}}<br>
                物料编码：{{item.ProductCode}}
              </td>
              <td>
                <el-tag :type="item.ConditionName | ConditionColor">{{item.ConditionName}}</el-tag>
              </td>
              <td>
                {{item.ProductBrandName}}
              </td>
              <td>
                {{item.ProductModelName}}
              </td>
              <td>
                {{item.ProductModuleName}}
              </td>
              <td>
                {{item.Quantity}}
              </td>
              <td>
                <el-select class="form-input" v-model="item.TrustTime" placeholder="请选择委托时长">
                  <el-option
                    v-for="t in TrustTimes"
                    :key="t.value"
                    :label="t.label"
                    :value="t.value">
                  </el-option>
                </el-select>
              </td>
            </tr>
          </tbody>
        </table>
        <el-button class="delete-btn" @click.native="deleteItem(index, item)">X</el-button>
      </div>
    </div>
    <div class="sumbit_box" slot="sumbit_box">
      <el-button @click.native="cancel">取消</el-button>
      <el-button type="primary" @click.native="sumbit">提交并等待客服联系</el-button>
    </div>
  </form-layout>
</template>

<script>
import FormLayout from '@/components/pages/Inventory/TrustFormLayout'
export default {
  data() {
    return {
      TrustTimes: [
        {label: '90天', value: 'rental'},
        {label: '120天', value: 'delegated'},
        {label: '180天', value: 'managed'},
        {label: '210天', value: 'manageds'},
      ],
      activebox: [],
    }
  },
  methods: {
    cancel: function() {
      this.$router.push('/trust')
    },
    sumbit: function() {
      this.activebox = []
      window.localStorage.setItem('activebox', JSON.stringify(this.activebox))
    },
    deleteItem: function(index, item) {
      this.$confirm('是否确认删除?', '删除批次', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.activebox.splice(index, 1)
        window.localStorage.setItem('activebox', JSON.stringify(this.activebox))
        this.$message({
          type: 'success',
          message: '删除成功!',
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
    initManaged: function() {
      this.activebox = JSON.parse(window.localStorage.getItem('activebox'))
      for (var a = 0; a < this.activebox.length; a++) {
        this.activebox[a].TrustTime = null
      }
    },
  },
  components: {
    FormLayout,
  },
  created() {
    this.initManaged()
  },
}
</script>

<style lang="less" scoped>
.form-layout .apply-box{
  display: none;
}
.form-input {
  width: 260px;
}
.list-layout .complex-table .sub-row-table .sub-body .text-center{
  border-right: 1px solid #dfe6ec;
  border-bottom: 1px solid #dfe6ec;
}
.main-content{
  .tab{
    .el-tabs__active-bar{
      background-color: rgba(0,0,0,0);
    }
  }
}
.add-btn:hover,.add-btn:focus{
  color: #FFFFFF;
  background: #2283CA;
}
.item-box{
  position: relative;
  padding:10px 20px;
  background-color: #fff;
  margin-bottom: 10px;
  border: 1px solid #E1E8EE;
  width: 90%;
  .el-select,.el-input{
    width: 100%;
  }
  .delete-btn{
    position: absolute;
    right: -60px;
    top: 35%;
    background-color: #FF4949;
    color: #fff;
    padding: 10px 12px;
    border-radius: 50%;
    border: none;
  }
  table{
    display: inline-block;
    label{
      display: block;
      margin-bottom: 5px;
    }
    td{
      padding: 5px 10px 5px 0;
    }
    td:last-child{
      padding-right: 0;
    }
  }
}
.sumbit_box{
  margin-top: 20px;
  text-align: right;
  p{
    text-align: right;
    font-size: 18px;
    color:  #1F2D3D;
    span{
      color: #FF4949;
    }
  }
  .el-button {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// TrustActivePage.vue?477922a6